/**
 * Derive a skill's drill-in display fields from the canonical item row.
 *
 * The row's structured fields (metadata projections: name/description/icon/
 * color) are the source of truth under the frontmatter contract; parsing the
 * content's inline frontmatter is only a fallback for rows minted before the
 * contract normalized them (the P2 backfill strips inline blocks, after which
 * the fallback simply never fires). Shared by the skill drill-in page and the
 * hover prefetch so the merge lives in ONE place.
 */
import type { ItemDetail } from "@bash/shared";
import { parseFrontmatter } from "./parseFrontmatter";

export type SkillDetailSource = Pick<
  Partial<ItemDetail>,
  "name" | "description" | "icon" | "color" | "content"
>;

export function parseSkillDetail(
  item: SkillDetailSource | null | undefined
): Record<string, string> {
  const out: Record<string, string> = {
    ...parseFrontmatter(item?.content ?? ""),
  };
  if (item?.name) out.name = item.name;
  if (item?.description) out.description = item.description;
  if (item?.icon) out.icon = item.icon;
  if (item?.color) out.color = item.color;
  return out;
}
